import { getPageTemplate } from "./aem";

export enum PageTemplates {
    PDP = "product-detail-page",
    BOX_DETAIL = "box-action-detail-page",
    STORE_DETAIL = "store-detail-page",
    ACCOUNT = "account-page",
    CHECKOUT = "checkout-page",
    CALCULATOR = "calculator-page",
    CONTENT = "content-page",
    HOME = "home-page",
    PRODUCT_CATEGORY = "product-category-page",
    SEARCH = "search-page",
    SHOPPING_CART = "shopping-cart-page"
}

export const isPageTemplate = (pageTemplate: PageTemplates) =>
    getPageTemplate() === pageTemplate;
